import { MultilingualString } from "../types/multilingual";

/**
 * 기존 titleKo, titleEn 형태의 데이터를 MultilingualString으로 변환
 */
export function convertToMultilingualString(
  koValue: string,
  enValue?: string,
): MultilingualString {
  const result: MultilingualString = {
    ko: koValue || "",
  };

  if (enValue) {
    result.en = enValue;
  }

  return result;
}

/**
 * MultilingualString을 기존 형태의 객체로 변환
 */
export function convertFromMultilingualString(
  multilingual: MultilingualString,
): { ko: string; en?: string } {
  return {
    ko: multilingual.ko || "",
    en: multilingual.en || undefined,
  };
}

/**
 * 아티클 데이터를 다국어 지원 형태로 변환하는 헬퍼
 */
export function createMultilingualArticle(article: {
  titleKo: string;
  titleEn?: string;
  contentKo: string;
  contentEn?: string;
}) {
  return {
    title: convertToMultilingualString(article.titleKo, article.titleEn),
    content: convertToMultilingualString(article.contentKo, article.contentEn),
  };
}

/**
 * 키워드 데이터를 다국어 지원 형태로 변환하는 헬퍼
 */
export function createMultilingualKeyword(keyword: {
  nameKo: string;
  nameEn?: string;
  descKo: string;
  descEn?: string;
  categoryNameKo: string;
  categoryNameEn?: string;
}) {
  return {
    name: convertToMultilingualString(keyword.nameKo, keyword.nameEn),
    description: convertToMultilingualString(keyword.descKo, keyword.descEn),
    categoryName: convertToMultilingualString(
      keyword.categoryNameKo,
      keyword.categoryNameEn,
    ),
  };
}

/**
 * 제품 데이터를 다국어 지원 형태로 변환하는 헬퍼
 */
export function createMultilingualProduct(product: {
  nameKo: string;
  nameEn?: string;
}) {
  return {
    name: convertToMultilingualString(product.nameKo, product.nameEn),
  };
}

/**
 * 이미지 설명을 다국어 지원 형태로 변환하는 헬퍼
 */
export function createMultilingualImageDescription(image: {
  descKo: string;
  descEn?: string;
}) {
  return {
    description: convertToMultilingualString(image.descKo, image.descEn),
  };
}
